exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".jwplayer{position:relative}.player_cta{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);padding:20px;background-color:hsla(0,0%,47%,.4);color:#ddd;text-decoration:none;font-family:helvetica,arial,sans-serif;font-size:28px;line-height:30px;letter-spacing:1px;text-align:center}.player_cta:hover{background-color:hsla(0,0%,74%,.4);color:#fff}.jwplayer.jw-state-complete .jw-display-icon-container,.player_qos_tracking_pixel{display:none}.jwplayer .jw-preview{background-size:100% 100%}.jwplayer.jw-flag-live .jw-controlbar .jw-text-alt{visibility:hidden;position:relative;display:block}.jwplayer.jw-flag-live .jw-controlbar .jw-text-alt:after{visibility:visible;position:absolute;top:1px;left:0;content:'Generating preview'}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/player.css
 ** module id = 8
 ** module chunks = 0
 **/